import React from "react";
import { useSelector } from "react-redux";
import ApiAccessEmptyState from "../../components/api/ApiAccessEmptyState";
import ApiPlayground from "../../components/api/ApiPlayground";

const AudienceApi = ({ audience, hasAccess = true }) => {
  const { currentBrand, brands } = useSelector((state) => state.brand);
  const { currentProject } = useSelector((state) => state.project);

  if (!hasAccess) {
    return <ApiAccessEmptyState />;
  }

  return (
    <ApiPlayground
      context="audience"
      currentBrand={currentBrand}
      brands={brands}
      audienceHash={audience?.hash || ""}
      projectHash={currentProject?.hash || currentBrand?.project_hash || ""}
    />
  );
};

export default AudienceApi;
